var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"information-marker",attrs:{"id":'infoMarker_' + _vm.uniqueId}},[_c('b-icon',{attrs:{"icon":"info-circle-fill"}})],1),_c('b-popover',{attrs:{"target":'infoMarker_' + _vm.uniqueId,"title":"","triggers":_vm.trigger ?? 'click',"placement":_vm.placement ?? 'top'}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }